export default "/images/vendor/flag-icon-css/flags/4x3/nz.svg?4dedf09b8933ec6f43903ba10d865d56";